@if ({
  product: product$ | async,
  image: image$ | async
  }; as type) {
  @if (type.product && type.image) {
    <div class="container">
      <span class="natural-rabatt"
      [routerLink]="
      {
        cxRoute: 'product',
        params: { code: type.product.naturalRabatt.product.code }
      } | cxUrl
    ">
        <cx-media [container]="type.image" format="product"> </cx-media>
        <div class="name">
          {{type.product.naturalRabatt.product.name}}
        </div>
        <!-- <div class="summary" *ngIf="type.product.naturalRabatt.product.summary">
        {{type.product.naturalRabatt.product.summary}}
      </div> -->
      <div class="info">
        {{ 'product.naturalRabattInfo' | cxTranslate : { knrnm: type.product.naturalRabatt.KNRNM, knrzm: type.product.naturalRabatt.KNRZM } }}
      </div>
      @if (type.product.naturalRabatt.product.ekPrice) {
        <div class="info">
          {{ "productDetails.ekPrice" | cxTranslate }}
          {{ type.product.naturalRabatt.product.ekPrice?.formattedValue  }}
        </div>
      }
    </span>
  </div>
}
}
